import { render, staticRenderFns } from "./SCase.vue?vue&type=template&id=5633616c"
import script from "./SCase.vue?vue&type=script&lang=js"
export * from "./SCase.vue?vue&type=script&lang=js"
import style0 from "./SCase.vue?vue&type=style&index=0&id=5633616c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports